<template>
  <b-container class="home-margin pad-0">
    <b-breadcrumb :items="breaditem" class="breadcrumb-white"></b-breadcrumb>
    <div class="new-details" v-if="show">
      <h2 class="new-details-title">
        {{ detailData.name ? detailData.name : "" }}
      </h2>
      <!-- <div class="project-details-text">
        <span class="new-details-span" style="margin-bottom:20px">{{
          detailData.projectTitle ? detailData.projectTitle : ""
        }}</span>
      </div> -->
      <div class="project-details-text">
        <span class="new-details-span">
          {{
            detailData.areas
              ? existData(detailData.areas[0], "provinceName", "")
              : ""
          }}
          {{
            detailData.areas && detailData.areas.length > 0
              ? existData(detailData.areas[0], "cityName", " - ")
              : ""
          }}{{
            detailData.areas &&
            detailData.areas.length > 0 &&
            existData(detailData.areas[0], "provinceName", "")
              ? " | "
              : ""
          }}{{
            changeDataTime(detailData.startDate) && detailData.startDate
              ? changeDataTime(detailData.startDate)
              : " 开始时间 "
          }}
          |
          <a class="collect-icon" v-if="!collect" @click.stop="collectProject">
            <img src="@/assets/img/icon/collect.png" />收藏
          </a>
          <a
            class="collect-icon collect-true"
            v-else
            @click.stop="collectProject"
          >
            <img src="@/assets/img/icon/collectTrue.png" />收藏
          </a>
        </span>
      </div>
      <img class="project-img" :src="getImgUrl(detailData.projectPhotoUrl)" />
      <div class="project-detail-content">
        <Title title="项目信息" :left="true"></Title>

        <p v-html="detailData.pqrojectDesc"></p>
      </div>
      <p>开始时间：{{ detailData.startDate }}</p>
      <p>结束时间：{{ detailData.endDate }}</p>
      <p>项目人数：{{ detailData.headcount + "人" }}</p>

      <div class="project-detail-content">
        <p>项目行业：</p>
        <div>
          <p>{{ industry }}</p>
        </div>
      </div>
      <div class="project-detail-content">
        <p>项目要求：</p>
        <div>
          <p v-html="detailData.projectRequire"></p>
        </div>
      </div>
      <div class="project-detail-content">
        <p>项目详情：</p>
        <div>
          <p v-html="detailData.projectDesc"></p>
        </div>
      </div>
      <div class="project-detail-content">
        <div
          class="project-roles"
          v-for="(item, index) in detailData.roles"
          :key="index + 1"
        >
          <p>任职要求：</p>
          <div class="require">
            <p
              v-for="(items, indexs) in changeData(item.knowledge)"
              :key="indexs"
            >
              {{ indexs + 1 }}、{{ items }}
            </p>
          </div>
          <!-- <p>{{ item.duty }}</p> -->
        </div>
      </div>
      <div class="company-header">
        <!-- <Title title="公司信息" :left="true"></Title> -->
        <div class="company-detail">
          <!-- <p>{{ detailData.customer ? detailData.customer.name : "" }}</p>
          <p>
            地区：{{
              detailData.areas && detailData.areas.length > 0
                ? existData(detailData.areas[0], "provinceName", "") +
                  existData(detailData.areas[0], "cityName", "") +
                  existData(detailData.areas[0], "districtName", " ")
                : ""
            }}
          </p>
          <p>行业：</p>
          <p v-if="detailData.customer">{{ detailData.customer.desc }}</p> -->
          <div class="more-btn flex-start">
            <b-button
              variant="primary"
              @click="
                () => {
                  if (detailData.status !== 'allow') {
                    this.$message.warning('该项目未开放');
                  } else {
                    if (logins) {
                      if (userAllData) {
                        this.visible = false;
                        this.visibles = true;
                      } else {
                        this.visible = true;
                      }
                    } else {
                      this.$router.push({
                        path: '/login',
                        query: {
                          redirect: location.href
                        }
                      });
                      this.$message.warning('请先登录');
                    }
                  }
                }
              "
            >
              申请项目
              <b-icon-arrow-right></b-icon-arrow-right>
            </b-button>
          </div>
        </div>
      </div>

      <div class="more-project home-margin">
        <Title title="其他相关项目" :left="true"></Title>
        <Project
          :data="projectData.data"
          :ProjectDetail="ProjectDetail"
        ></Project>
      </div>
    </div>
    <a-modal
      v-model="visibles"
      title="选择要申请的角色"
      @ok="handleOks"
      cancelText="取消"
      okText="确定"
      class="form-all"
    >
      <a-select v-model="roleData" style="width:100%">
        <a-select-option
          :value="item.id"
          v-for="(item, index) in roleList"
          :key="index"
          >{{ item.major }}</a-select-option
        >
      </a-select>
    </a-modal>
    <a-modal
      class="talent-modal"
      :visible="visible"
      cancelText="取消"
      @ok="handleOk"
      @cancel="cancel"
      okText="我的账户"
    >
      <template slot="title">
        <div class="modal-icon">
          <img src="@/assets/img/new/user/ts.png" alt />
          您的个人资料未完善
        </div>
      </template>
      <p>
        为确保申请项目成功，请先点击我的账户跳转至我的账户完善个人、教育经历、求职意向信息
      </p>
    </a-modal>
  </b-container>
</template>
<script>
import Api from "@/apis";
import Project from "@/components/project/index.vue";
import publicChange from "@/assets/js/index.js";
// let id = 0;
export default {
  name: "details-project",
  data() {
    return {
      routerId: this.$route.query.id || 0,
      show: true,
      visible: false,
      collectArr: [],
      listType: 1,
      collect: false,
      logins: false,
      detailData: {},
      visibles: false,
      roleList: [],
      userAllData: false,
      industry: "信息技术",
      roleData: "",
      projectData: [],
      knowledge: [],
      breaditem: [
        {
          text: "项目机会",
          to: "/product/list"
        },
        {
          text: "项目详情"
        }
      ],
      DetailsList: [],

      active: 0
    };
  },
  watch: {
    detailData: {
      deep: true,
      handler: function() {}
    }
  },
  components: {
    Project
  },
  mounted() {
    this.getCollectProject();
    this.getProjectById();
    this.getUser();
    if (this.login()) {
      this.logins = true;
    } else {
      this.logins = false;
      this.$message.warning("请先登录");
      this.$router.push({ path: "/login", query: { redirect: location.href } });
    }
  },
  methods: {
    //获取用户详细信息
    async getUser() {
      try {
        const data = await Api.User.getUserDetail();
        this.user = data;
        if (data) {
          //根据数据判断展示
          if (
            data.educations &&
            data.educations.length > 0 &&
            data.intentions &&
            data.intentions.length > 0 &&
            data.info.email !== "" &&
            data.info.provinceCode !== ""
          ) {
            this.userAllData = true;
          } else {
            this.userAllData = false;
          }
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    //自荐项目
    async handleOks() {
      let recommnd = {
        projectId: this.routerId,
        projectRoleId: this.roleData
      };
      try {
        const recommndProject = await Api.User.RecommendIntention(recommnd);
        if (recommndProject) {
          this.$message.success("申请成功,请耐心等待审核");
        } else {
          this.$message.error("申请失败,请重试");
        }
        this.visibles = false;
      } catch (e) {
        this.$message.error(e);
      }
    },
    //获取是否有收藏
    async getCollectProject() {
      try {
        let query = {
          type: "project",
          current: 1
        };
        const data = await Api.Collection.getCollection(query);
        if (data.data && data.data.length > 0) {
          let arr = [];
          data.data.map(item => {
            arr.push(item.project.id);
            this.collectArr = arr;
            if (arr.indexOf(parseInt(this.routerId)) > -1) {
              this.collect = true;
            } else {
              this.collect = false;
            }
          });
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    async collectProject() {
      if (!this.collect) {
        try {
          let query = {
            objectId: this.routerId,
            objectType: "project"
          };
          const data = await Api.Collection.createCollection(query);
          if (data) {
            this.$message.success("收藏成功");
            this.collect = true;
            this.getCollectProject();
          } else {
            this.$message.error("收藏失败");
          }
        } catch (e) {
          this.$message.error(e);
        }
      } else {
        try {
          let query = {
            objectId: this.routerId,
            objectType: "project",
            id: this.routerId
          };
          const data = await Api.Collection.deleteCollection(query);
          if (data) {
            this.getCollectProject();
            this.collect = false;
            this.$message.success("取消收藏成功");
          } else {
            this.$message.error("取消收藏失败");
          }
        } catch (e) {
          this.$message.error(e);
        }
      }
    },
    //右边切换操作
    ListClick(index) {
      this.active = index;
      this.show = true;
      this.getProjectById(index);
    },
    //获取项目内容
    async getProjectById(id) {
      const query = {
        pageSize: 6,
        current: 1,
        filters: {
          relevance: 1
        }
      };

      if (id) {
        try {
          this.active = parseInt(id);
          const data = await Api.Project.getProjectId(id);
          query.filters.categoryId = data.categoryId;
          console.log(query);
          const datas = await Api.Project.getProjectRecomment(query);
          this.projectData = datas;
          this.detailData = data;
          this.roleList = data.roles;
        } catch (e) {
          this.$message.error(e);
        }
      } else {
        try {
          const router = this.$route.query.id;
          this.active = parseInt(router);
          const data = await Api.Project.getProjectId(router);

          query.filters.categoryId = data.categoryId;

          const industry = await Api.Global.getIndustry(data.industry);
          this.trees(industry.data, data.industry);
          const datas = await Api.Project.getProjectRecomment(query);
          this.projectData = datas;
          this.detailData = data;
          this.roleList = data.roles;
        } catch (e) {
          this.$message.error(e);
        }
      }
    },
    companyDeatils() {
      this.show = false;
      window, scrollTo(0, 0);
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    existData(data, index, text) {
      return publicChange.existData(data, index, text);
    },
    //跳转其他详情并判断
    ProjectDetail(id) {
      this.getProjectById(id);
      this.routerId = id;
      if (this.collectArr.indexOf(this.routerId) > -1) {
        this.collect = true;
      } else {
        this.collect = false;
      }
      window, scrollTo(0, 0);
    },
    login() {
      return publicChange.userLogin();
    },
    changeData(text) {
      if (text && text != "") {
        const texts = text.split(",");
        return texts;
      } else {
        return [];
      }
    },
    //转换时间戳
    changeDataTime(date) {
      let time = new Date(date);
      return this.$moment(time).format("YYYY.MM.DD");
    },
    handleOk() {
      this.$router.push("/user/talent");
    },
    cancel() {
      this.visible = false;
    },
    goBack() {
      this.visible = false;
    },
    trees(data, industry) {
      var best = "";
      if (industry.pid == 0) {
        this.industry = industry.name;
      } else {
        var tis = this.treesof(data, industry);
        best = tis.name + " > " + industry.name;
        this.industry = best;
        if (tis.pid != 0) {
          var bs = this.treesof(data, tis);
          best = bs.name + " > " + tis.name + " > " + industry.name;
          this.industry = best;
          if (bs.pid != 0) {
            var as = this.treesof(data, bs);
            best =
              as.name +
              " > " +
              bs.name +
              " > " +
              tis.name +
              " > " +
              industry.name;
            this.industry = best;
            if (as.pid != 0) {
              var ts = this.treesof(data, as);
              best =
                ts.name +
                " > " +
                as.name +
                " > " +
                bs.name +
                " > " +
                tis.name +
                " > " +
                industry.name;
              this.industry = best;
            }
          }
        }
      }
    },
    treesof(data, industry) {
      for (var i of data) {
        if (i.id == industry.pid) {
          return i;
        } else {
          for (var j of i.children) {
            if (j.id == industry.pid) {
              return j;
            } else {
              for (var k of j.children) {
                if (k.id == industry.pid) {
                  return k;
                } else {
                  for (var e of k.children) {
                    if (e.id == industry.pid) {
                      return e;
                    } else {
                      for (var a of e.children) {
                        if (a.id == industry.pid) {
                          return a;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-icon {
  display: flex;
  align-items: center;
}
.modal-icon img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}
</style>
